// import { getFile } from "api/fileManager";

const pdfPreviewConfig = {
  getFile: () => null
};

export default pdfPreviewConfig;